export default "__VITE_ASSET__COtpMMwa__"